export const jsonFetch = async (...args) => {
  const response = await fetch(...args)
  const json = await response.json()
  if (response.ok) {
    return json
  } else {
    throw json
  }
}
